import { Car } from 'lucide-react';
import { IslamicSymbol } from '../ui/islamic-symbol';
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Separator } from "../ui/separator";
import { useLanguage } from '../../contexts/LanguageContext';
import type { Car as CarType } from "../Listings";

interface CarSummaryProps {
  car: CarType;
}

export function CarSummary({ car }: CarSummaryProps) {
  const { t } = useLanguage();
  
  return (
    <Card className="border-[#f91bdc]/20 sticky top-20">
      <CardHeader>
        <CardTitle className="flex items-center space-x-2">
          <Car className="text-[#f91bdc]" size={24} />
          <span>{t('buyingForm.yourSelectedCar')}</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          <div className="h-32 bg-gradient-to-br from-[#f91bdc]/10 to-[#f91bdc]/20 rounded-lg flex items-center justify-center">
            <Car size={48} className="text-[#f91bdc]/60" />
          </div>
          
          <div>
            <h3 className="font-semibold text-lg">{car.year} {car.make} {car.model}</h3>
            <p className="text-gray-600">{car.type} • {car.dealer}</p>
            <p className="text-xs text-gray-500">{car.location.city}, {car.location.stateProvince}, {car.location.country}</p>
          </div>
          
          <Separator />
          
          <div className="space-y-2">
            <div className="flex justify-between">
              <span className="text-gray-600">{t('car.monthlyPayment')}:</span>
              <span className="font-semibold text-[#f91bdc]">${car.monthlyPayment}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{t('buyingForm.term')}:</span>
              <span className="font-semibold">{car.termMonths} {t('car.months')}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">{t('car.totalPrice')}:</span>
              <span className="font-semibold">${(car.monthlyPayment * car.termMonths).toLocaleString()}</span>
            </div>
          </div>
          
          <div className="p-3 bg-[#f91bdc]/5 rounded-lg">
            <div className="flex items-center space-x-2">
              <IslamicSymbol size={16} className="text-[#f91bdc]" />
              <span className="text-sm font-medium">{t('hero.shariahCompliant')}</span>
            </div>
            <p className="text-xs text-gray-600 mt-1">
              {t('buyingForm.interestFreeFinancing')}
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}